import {toArray} from 'external/lodash'
import {connect} from 'external/react'
import {clsx, Box, Button, AddIcon, makeStyles} from 'external/material'

import UploadedFiles from 'components/Uploads/UploadedFiles'
import UploadProgress from 'components/Uploads/UploadProgress'
import {setUploadFile} from 'components/Uploads/redux/actions'

const useStyles = makeStyles(createStyles)

function UploadFiles(props) {
    const {server, folder, setUploadFile, translate = a => a, buttonText, readOnly, downloadServer } = props;
    const classes = useStyles()    

    const handleAttachFile = e => {     
        setUploadFile(toArray(e.target.files).map(file => ({file, server, folder})))
        e.target.value = '' // to clear the current file
    }

    if(readOnly) {
      return(
        <Box className={classes.uploads}>
          <UploadedFiles translate={translate} downloadServer={downloadServer} /> 
        </Box>
      )
    } 

    return (
      <Box className={classes.uploads}>
          <Button  
              className={clsx(classes.root, 'button')}
              variant="contained"
              component="label"
              >
              <AddIcon fontSize={'small'} focusable={false} />
              {buttonText??'Upload'}
              <input type="file" multiple hidden onChange={handleAttachFile} />
          </Button>
          <UploadProgress translate={translate} downloadServer={downloadServer} />
      </Box>
    )
}

const mapDispatchToProps = dispatch => ({ 
  setUploadFile: files => dispatch(setUploadFile(files))
})

export default connect(null, mapDispatchToProps)(UploadFiles)
 

function createStyles(theme) {   
    return {
      uploads: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '14px',
        '& a': {
          color: '#639de2',
          textDecoration: 'none',
          cursor: 'pointer',
          position: 'relative',
          top: -7,
          '&:hover': {
            textDecoration: 'underline'
          }
        },
        '& span.MuiButton-label': {
          textTransform: 'capitalize',
          textAalign: 'left',
          justifyContent: 'flex-start'
        },
        '& .button': {
          textTransform: 'capitalize',
          color: '#639de2',
          fontWeight: '600',
          fontSize: '14pt',
          backgroundColor:'transparent',
          border: 'solid 1px #93c4ed',
          boxShadow: 'none',
          textAlign: 'left',
          padding: 8,
          margin: 0,
          "&:hover": {
            backgroundColor: "transparent"
          },
          "&:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
}
